// Add packege to show error message
export const EMPTY_PACKAGE_NAME_ERROR = "Package name is required";
export const EMPTY_APPLICABLE_TO_ERROR = "Please enter a valid applicable to";
export const EMPTY_TOTAL_COST_OF_SERVICES_ERROR = "Please enter a valid total cost of services";
export const EMPTY_DEFAULT_PACKAGE_PRICE_ERROR = "Default price is required";
export const EMPTY_DEFAULT_DISCOUNT_ERROR = "Please enter a valid default discount";
export const EMPTY_THRESHOLD_PRICE_ERROR = "Threshold price is required";
export const EMPTY_MINIMUM_PRICE_ERROR = "Minimum Price is required";
export const EMPTY_THRESHOLD_DISCOUNT_ERROR = "Please enter a valid threshold discount";
export const EMPTY_MAXIMUM_DISCOUNT_ERROR = "Please enter a valid maximum discount";


// create Service Error
export const EMPTY_SERVICE_NAME_ERROR = "Name of service is required";
export const EMPTY_SERVICE_DESCRIPTION_ERROR = "Description is required";
export const EMPTY_SERVICE_BENEFIT_ERROR = "Benefit is required";
export const EMPTY_SERVICE_CHARGE_BASIS_ERROR ="Please select a charge basis";
export const EMPTY_SERVICE_DEFAULT_CHARG_BASIS = "Please Select At least one Default Charge Basis";

export const EMPTY_SERVICE_PRICE_RATE_ERROR = "Price rate is required";
export const EMPTY_SERVICE_MIN_BASE_PRICE_ERROR = "Minimum base price is required";
export const EMPTY_SERVICE_CHARGE_TYPE_ERROR = "Charge type is required";
export const EMPTY_SERVICE_INCREMENTAL_RULE_ERROR = "Please enter an incremental price";
export const EMPTY_CHARGE_BASIS  ="Please select at least two charge basis."
export const EMPTY_CHARGE_BASIS_ONE  ="Please select at least One Different charge basis."
export const EMPTY_ADD_ON_PRICE = "Add-on price is required for this charge basis.";




export const EMPTY_SERVICE_TYPE_ERROR = "Please Select a Service Type";
export const EMPTY_PRICE_ERROR = "Price is required";
export const PRICE_IS_ZERO = "Price should be greater than 0";


// Create Chage Basis Error
export const EMPTY_CHARGE_BASIS_NAME_ERROR = "Charge basis name is required";
export const EMPTY_CHARGE_BASIS_TYPE_ERROR = "Basis Type is required";
export const EMPTY_NAME_OF_UNIT_ERROR = "Name of unit is required";
export const EMAPTY_TAGS_ERROR = "Tags are required"
export const EMAPTY_BAND_VALUE_ERROR = "Value field is required"
export const EMAPTY_PRICE_PER_UNIT_ERROR = "Price per unit is required";
export const EMPTY_MIN_BAND_BASIS_ERROR = "Min value is required";
export const EMPTY_MAX_BAND_BASIS_ERROR = "Max value is required";
export const EMPTY_FREQUENCY_NAME_ERROR = "Frequency name is required";
export const EMPTY_FREQUENCY_VALUE_ERROR = "Frequency value is required";
export const EMPTY_YESNO_ERROR = "Value field is required";
export const EMPTY_PRICING_QUERY = "Pricing Query is required";


// Error Messages
export const ERROR_MESSAGES = {
  // Package Errors
  EMPTY_PACKAGE_NAME: "Package name is required",
  EMPTY_APPLICABLE_TO: "Please enter a valid applicable to",
  EMPTY_TOTAL_COST_OF_SERVICES: "Please enter a valid total cost of services",
  EMPTY_DEFAULT_PACKAGE_PRICE: "Default price is required",
  EMPTY_DEFAULT_DISCOUNT: "Please enter a valid default discount",
  EMPTY_THRESHOLD_PRICE: "Threshold price is required",
  EMPTY_MINIMUM_PRICE: "Minimum Price is required",
  EMPTY_THRESHOLD_DISCOUNT: "Please enter a valid threshold discount",
  EMPTY_MAXIMUM_DISCOUNT: "Please enter a valid maximum discount",

  // Service Errors
  EMPTY_NUMBER_OF_SERVICE: "Name of service is required",
  EMPTY_SERVICE_TYPE: "Please Select a Service Type",
  EMPTY_PRICE: "Price is required",
  PRICE_IS_ZERO: "Price should be greater than 0",

  // Charge Basis Errors
  EMPTY_CHARGE_BASIS_NAME: "Charge basis name is required",
  EMPTY_CHARGE_BASIS_TYPE: "Basis Type is required",
  EMPTY_NAME_OF_UNIT: "Name of unit is required",
  EMPTY_TAGS: "Tags are required",
  EMPTY_BAND_VALUE: "Value field is required",
  EMPTY_PRICE_PER_UNIT: "Price per unit is required",
  EMPTY_MIN_BAND_BASIS: "Min value is required",
  EMPTY_MAX_BAND_BASIS: "Max value is required",
  EMPTY_FREQUENCY_NAME: "Frequency name is required",
  EMPTY_FREQUENCY_VALUE: "Frequency value is required",
  EMPTY_YESNO: "Value field is required",

  // Quote Template Errors
  EMPTY_TEMPLET_NAME: "Template name is required",
  EMPTY_TEMPLET_CATEGORY: "Category is required",
  EMPTY_COMMON_TEMPLET_NAME: "Heading is required",
  EMPTY_TRIGGER_EVENT: "Trigger Event is required",
  EMPTY_TEMPLET_BODY: "Body content is required",

  // Email Template Errors
  EMPTY_EMAIL_NAME: "Name is required",

  // Quote Errors
  EMPTY_CLIENT_NAME: "Please select Client",
  EMPTY_SECONDARY_QUOTE_TYPE: "Please enter Secondary Quote type",
  EMPTY_BUSINESS_TYPE: "Please enter Business type",
  EMPTY_CONTRACT_OWNER: "Please enter Contract owner",
  EMPTY_ENQUIRY_TYPE: "Please enter Enquiry type",
  EMPTY_CHANNEL: "Please enter Channel",
  EMPTY_QUOTE_TYPE: "Please enter Quote type",
  ALERT_MSG_ADHOC_RECCURING_SERVICES: "Please select One Off or Reccuring services",
  EMPTY_EMAIL: "Please enter Email",
  INVALID_EMAIL: "Please enter valid Email",
  EMPTY_SUBJECT: "Please enter Subject",
  EMPTY_SELECT_TEMPLET: "Please select Template",
  EMPTY_SECONDARY_CONTRACT_TYPE: "Please enter Secondary Contract type",
  EMPTY_CONTRACT_TYPE: "Please enter Contract type",
};// Quote templet Error
export const EMPTY_TEMPLET_NAME_ERROR = "Template name is required";
export const EMPTY_TEMPLET_CATEGORY_ERROR = "Category is required";
export const EMPTY_COMMON_TEMPLET_NAME_ERROR = "Heading is required";
export const EMPTY_TRIGGER_EVENT_ERROR = "Trigger Event is required";
export const EMPTY_TEMPLET_BODY_ERROR = "Body content is required";


// Email Templet Error
export const EMPTY_EMAIL_NAME_ERROR = "Name is required";


// Quote Error
export const EMPTY_CLIENT_NAME_ERROR = "Please select Client";
export const EMPTY_SECONDARY_QUOTE_TYPE_ERROR = "Please enter Secondary Quote type";
export const EMPTY_BUSINESS_TYPE_ERROR = "Please enter Business type";
export const EMPTY_CONTRACT_OWNER_ERROR = "Please enter Contract owner";
export const EMPTY_ENQUIRY_TYPE_ERROR = "Please enter Enquiry type";
export const EMPTY_CHANNEL_ERROR = "Please enter Channel";
export const EMPTY_QUOTE_TYPE_ERROR = "Please enter Quote type";
export const ALERT_MSG_ADHOC_RECCURING_SERVICES = "Please select One Off or Reccuring services";
export const EMPTY_EMAIL_ERROR = "Please enter Email";
export const INVALID_EMAIL_ERROR = "Please enter valid Email";
export const EMPTY_SUBJECT_ERROR = "Please enter Subject";
export const EMPTY_SELECT_TEMPLET_ERROR = "Please select Template";
export const EMPTY_SECONDARY_CONTRACT_TYPE_ERROR = "Please enter Secondary Contract type";
export const EMPTY_CONTRACT_TYPE_ERROR = "Please enter Contract type";

// 
export const EMPTY_CC_EMAIL_ERROR = "Please enter CC Email";
export const INVALID_CC_EMAIL_ERROR = "Please enter valid CC Email";
export const EMPTY_BCC_EMAIL_ERROR = "Please enter BCC Email";
export const INVALID_BCC_EMAIL_ERROR = "Please enter valid BCC Email";







